<template>
  <Modal v-model="modal" :title="$t('title.w51')" :mask-closable="false" class="unpledge">
    <div>
      <Row class="item" type="flex" align="middle">
        <Col span="7">
          <b>{{$t('label.w96')}}</b>
        </Col>
        <Col span="17">
          <span class="dn">{{info.Name}}</span>
        </Col>
      </Row>
      <Row class="item" type="flex" align="middle">
        <Col span="7">
          <b>{{$t('label.w197')}}</b>
        </Col>
        <Col span="17">
          <span class="amount">¥ {{info.CreditAmount | money}}</span>
        </Col>
      </Row>
      <div class="info">
        <Row>
          <Col span="8">
            <b>{{$t('label.w160')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.UserOperatorName}}</span>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <b>{{$t('label.w195')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.UserOperatorAccount}}</span>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <b>{{$t('label.w162')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.UserOperatorVerifyInfo}}</span>
          </Col>
        </Row>
      </div>
      <Form label-position="top" :model="form" ref="form" :rules="formRule">
        <FormItem :label="$t('label.w21')" prop="pwd" class="formitem">
          <Input type="password" :placeholder="$t('pl.p11')" v-model="form.pwd"/>
          <router-link :to="{name:'security'}" class="text-primary">{{$t('nav.w58')}}</router-link>
        </FormItem>
        <FormItem :label="verificationType==2?$t('label.w35'):$t('label.w36')" prop="code" class="formitem">
          <a href="javascript:;" class="text-primary" v-if="verificationType==2" @click="verificationType=1">{{$t('nav.w59')}}</a>
          <a href="javascript:;" class="text-primary" v-if="verificationType==1" @click="verificationType=2">{{$t('nav.w60')}}</a>
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p8')" v-model="form.code"/>
            </Col>
            <Col span="6">
              <Codebtn type="SendRelievePledgeCode" :to="verificationType"/>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button
        type="primary"
        :loading="loading"
        :disabled="form.pwd==''||form.code==''"
        @click="submit"
      >{{$t('btn.b13')}}</Button>
    </template>
  </Modal>
</template>
<script>
import Codebtn from "@/components/sendCodeButton";
import formRule from "@/libs/formRule"
import Rsa from "@/libs/Rsa"
export default {
  components: { Codebtn },
  data() {
    return {
      modal: false,
      info: {},
      loading: false,
      verificationType: 2, // 1邮箱 2手机
      form: {
        pwd: "",
        code: ""
      },
      formRule: {
        pwd: formRule.pwdUse,
        code: formRule.code
      }
    };
  },
  methods: {
    async submit() {
      let valid = await this.$refs.form.validate();
      if (!valid) return;

      let id = this.info.Id;
      this.loading = true;

      let res = await this.$axios.post("/Member/RZJPledge/RelievePledge", {
        verificationType: this.verificationType,
        pledgeId: id,
        transactionPassword: Rsa(this.form.pwd),
        code: this.form.code
      });

      this.loading = false;
      res.throw();
      if (!res.err) {
        this.modal = false;
        this.$emit("done");
      }
    },
    reset() {
      this.$refs.form.resetFields();
    }
  },
  watch: {
    modal(v) {
      if (!v) this.reset();
    }
  }
};
</script>
<style lang="less" scoped>
.unpledge {
  /deep/ .ivu-modal-body {
    padding-top: 15px;
  }
}
.info {
  background: #f1f2f5;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 35px;
  margin-bottom: 25px;
  margin-top: 15px;
}
b {
  font-weight: normal;
  color: #7b7b7c;
}
.item {
  padding: 10px 0;
  .dn {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }
  .amount {
    color: #ff6106;
    font-size: 18px;
    font-weight: bold;
  }
}
.agree {
  margin-top: 10px;
}
.formitem{
  position: relative;
  a{
    position: absolute;
    right: 0;
    top:-18px;
    line-height: 1;
  }
}
</style>
